export function hhmmss(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
}

/**
 * Duración legible.
 *
 * A partir de cien horas los minutos son ruido y además no caben: «15.903 h»
 * se lee de un vistazo, «15903 h 29 min» se sale de la tarjeta.
 */
export function hhmm(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  if (h >= 100) return `${new Intl.NumberFormat('es-ES').format(h)} h`;
  return `${h} h ${String(m).padStart(2, '0')} min`;
}

export function initials(fullName: string): string {
  const parts = fullName.trim().split(/\s+/);
  const first = parts[0]?.[0] ?? '';
  const second = parts.length > 1 ? parts[parts.length - 1]![0] ?? '' : '';
  return (first + second).toUpperCase();
}

export function qty(value: number): string {
  return new Intl.NumberFormat('es-ES', { maximumFractionDigits: 3 }).format(value);
}

export function percent(value: number): string {
  return `${Math.round(value * 100)}%`;
}

export function shortDate(iso: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso.length <= 10 ? `${iso}T00:00:00` : iso);
  return new Intl.DateTimeFormat('es-ES', { day: '2-digit', month: '2-digit' }).format(d);
}

export function clockTime(date: Date): string {
  return new Intl.DateTimeFormat('es-ES', { hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(date);
}

export function longDate(date: Date): string {
  return new Intl.DateTimeFormat('es-ES', { weekday: 'long', day: 'numeric', month: 'long' }).format(date);
}
